export const UPDATE_CART = "UPDATE_CART"
export const REMOVE_FROM_CART = "REMOVE_FROM_CART"
export const ORDER_CONFIRMED = "ORDER_CONFIRMED"

